module.exports = __webpack_public_path__ + "img/nginx.ec56c8e9.svg";